<template>
  <button @click="$router.go(-1)" class="btn btn-info">Go Back</button>
</template>

<script>
export default {

}
</script>

<style>

</style>